// import Skeleton from "react-loading-skeleton";
// import "react-loading-skeleton/dist/skeleton.css";

// const LeadCardSkeleton = () => {
//   return (
//     <div className="bg-white rounded-xl shadow p-4 mb-4 space-y-2">
//       <Skeleton height={20} width="100%" />
//       <Skeleton height={16} width="100%" />
//       <Skeleton height={14} width="100%" />
//     </div>
//   );
// };

// export default LeadCardSkeleton;
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

interface LeadCardSkeletonProps {
  height?: number | string; // ✅ optional
}

const LeadCardSkeleton = ({ height = 253 }: LeadCardSkeletonProps) => {
  return (
    <div className="shadow-sm rounded-xs border-gray-300 mb-4 transition-all duration-300 ease-in-out">
      <Skeleton
        height={height} // ✅ dynamic height
        width="100%"
        baseColor="#d1d5db" // Tailwind gray-300
        // highlightColor="#e5e7eb" // Tailwind gray-200
      />
    </div>
  );
};

export default LeadCardSkeleton;
